import {withApollo} from 'react-apollo';
import DefaultForm from '@appComponents/DefaultForm';
import {getLink} from '@appComponents/Link';
import {convertToInt} from '@utils/helpers';

class ClientAvApiKeyForm extends DefaultForm {
    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if(this.props.formParams !== prevProps.formParams) {
            if (null !== this.props.formParams.id && this.props.GraphQLEntityData.clientApiKey) {
                const clientApiKey = this.props.GraphQLEntityData.clientApiKey;

                this.setField('id', {defaultValue: this.props.formParams.id});
                this.setField('description', {defaultValue: clientApiKey.description});
            }
        }
    }

    renderSaveButton = () => {
        if (this.props.formParams.id) {
            return super.renderSaveButton();
        }

        return super.renderSaveButton({content: 'Generate'});
    };

    renderDeleteButton = () => {
        return null;
    };

    prepareDataForSubmit = (data) => {
        let dataToSave;

        if (data.id) {
            dataToSave = {
                id: convertToInt(data.id),
                description: data.description || null,
            };
        } else {
            dataToSave = {
                ...data, client: convertToInt(this.props.formParams.clientId),
                environment: convertToInt(data.environment),
                description: data.description || null,
            };
        }

        return dataToSave;
    };

    renderErrors(errorData) {
        const link = getLink('clients.apiKey.index', {
            id: this.props.formParams.clientId || null,
        });

        super.renderErrors(errorData, 'API key', link);
    }
}

export default withApollo(ClientAvApiKeyForm);
